import {onDocumentLoaded} from "@plaudit/frontend-apis";
import {
	addChosenLocaleUpdater,
	getAvailableLocales,
	getChosenLocale,
	pageSatisfiesLanguageRequirement
} from "../../site/lib/cookie-helpers";

onDocumentLoaded(() => {
	const languagePicker = document.body.querySelector<HTMLDialogElement>("dialog.wp-block-plaudit-language-picker-popup");
	// We only want to show the popup if it exists, the current page does not satisfy the language requirement, AND the user has not chosen a language
	// The last condition works because we check whether there is a page that actually matches the user's chosen language and then redirect them to it via an inline script
	if (languagePicker && !pageSatisfiesLanguageRequirement() && getChosenLocale() === null) {
		const availableLocales = getAvailableLocales();
		if (Object.keys(availableLocales).length > 1) {
			languagePicker.querySelectorAll("a.wpml-ls-link").forEach(addChosenLocaleUpdater);
			languagePicker.showModal();
		}
	}
});
